
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookies-policy",
      function () {
        return require("private-next-pages/cookies-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cookies-policy"])
      });
    }
  